<template>
<div class="torvandom-header">
    <div class="torvandom-nav-center">
        <div class="torvandom-nav-log">
            <img src="../assets/images/logo-b.png" alt="">
        </div>
        <div class="torvandom-nav-hash">
            <ul>
                <li v-for="(item, index) in bannerList" :key="index">
                    <a href="#/" v-if="!item.code" :class="curHash == 'home'?'actived' : ''">{{item.name}}</a>
                    <a :href="`#/${item.code}`" v-else-if="item.code && index==1" :class="curHash == item.code?'actived' : ''">{{item.name}}</a>
                    <a href="javascript:void()" v-else :class="curHash == item.code?'actived' : ''">{{item.name}}</a>
                </li>
            </ul>
        </div>
        <div class="torvandom-nav-right">
            <img src="data:image/svg+xml;base64,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" alt="">
            <div @click="changeLang" class="torvandom-lang">{{langText}}</div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data () {
        return {
            langText: '中文简体'
        }
    },
    props: {
        curHash: {
            type: String,
            default: ''
        }
    },
    methods: {
        changeLang () {
            let lng = window.localStorage.getItem('lng-torvandom')
            if (lng !== 'en') {
                lng = 'en'
                this.langText = 'ENG'
            } else {
                lng = 'zh-CN'
                this.langText = '中文简体'
            }
            window.localStorage.setItem('lng-torvandom', lng)
            this.$emit('updateLang', lng)
            return this.switchLang(lng)
        }
    },
    mounted () {
        let lng = window.localStorage.getItem('lng-torvandom')
        if (lng === 'en') {
            this.langText = 'ENG'
        } else {
            this.langText = '中文简体'
        }
    },
    computed: {
        bannerList () {
            return [
                {name: this.$t('home'), code: ''},
                {name: this.$t('product'), code: 'product'},
                {name: this.$t('server'), code: 'server'},
                {name: this.$t('case'), code: 'case'},
                {name: this.$t('jobs'), code: 'jobs'},
                {name: this.$t('about'), code: 'about'}
            ]
        }
    }
}
</script>

<style scoped lang="less">
.torvandom-header{
    position: relative;
    &::after{
        position: absolute;
        content: '';
        clear: both;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: #e8e2e2;
        transform-origin: 50% 50%;
        transform: scaleY(0.5);
    }
}
.torvandom-nav-center{
    width: 72%;
    margin: auto;
    display: flex;
    align-items: center;
    height: 88px;
    .torvandom-nav-log{
        margin-right: 50px;
        img{
            width: 224.5px;
            height: 33.8px;
        }
    }
    .torvandom-nav-hash{
        flex: 1;
        ul{
            display: flex;
            align-items: center;
            li{
                margin: 0 20px;
                font-size: 18px;
                white-space: nowrap;
                a{
                    color: #333;
                    font-weight: 500;
                    &.actived{
                        color: #e14c46;
                        position: relative;
                        &::after{
                            position: absolute;
                            clear: both;
                            content: '';
                            bottom: -31px;
                            left: 8px;
                            right: 8px;
                            z-index: 1;
                            height: 3px;
                            background: #e14c46;
                            -webkit-transform-origin: 50% 50%;
                            transform-origin: 50% 50%;
                            border-radius: 2px;
                        }
                    }
                }
            }
        }
    }
    .torvandom-nav-right{
        display: flex;
        align-items: center;
        height: 100%;
        white-space: nowrap;
        img{
            margin-right: 12px;
        }
        .torvandom-lang{
            &:hover{
                cursor: pointer;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue